import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { SurveyContext } from "../context/SurveyContext";
import { getProfilePicture } from "../utils/avatar";

const UserListModal = ({ users, title, onClose }) => {
  const { condition } = useContext(SurveyContext);

  return (
    <div className="fixed inset-0 bg-spiders-bg-dark/80 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="spiders-card p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4 pb-4 border-b border-spiders-border">
          <h2 className="text-xl font-bold text-spiders-text-primary">{title}</h2>
          <button
            onClick={onClose}
            className="text-spiders-text-muted hover:text-spiders-text-primary p-2 rounded-full hover:bg-spiders-bg-elevated transition-colors"
          >
            <FaTimes />
          </button>
        </div>
        <ul className="space-y-3 max-h-96 overflow-y-auto">
          {users.length === 0 ? (
            <li className="text-center py-8 text-spiders-text-muted">
              No users to display
            </li>
          ) : (
            users.map((user) => (
              <li
                key={user._id}
                className="flex items-center space-x-3 p-3 rounded-lg hover:bg-spiders-bg-elevated transition-colors"
              >
                <img
                  src={getProfilePicture(user.username, user.avatarSeed)}
                  alt={user.username}
                  className="w-10 h-10 rounded-full border border-spiders-border"
                />
                <div className="flex-1 min-w-0">
                  <Link
                    to={`/profile/${user.username}?condition=${condition}`}
                    className="text-spiders-text-primary hover:text-spiders-primary-400 font-bold flex items-center gap-1.5 transition-colors"
                    onClick={onClose}
                  >
                    {user.username}
                  </Link>
                  <p className="text-spiders-text-muted text-sm">@{user.username}</p>
                  {user.bio && (
                    <p className="text-spiders-text-secondary text-sm mt-1 line-clamp-2">{user.bio}</p>
                  )}
                </div>
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  );
};

export default UserListModal;
